import { Controller } from "@hotwired/stimulus"

// The landing page's plan packet: the ready-made mixes (Careful, Balanced,
// Bold) come straight from RiskQuiz::PRESETS, so the packet always shows the
// real split the app would set up. Left alone, it loops through the three
// mixes; the first tap on a chip hands control to the visitor and the loop
// stops, and so does the first touch on a slider. Every change is announced
// as packet:mix, which the hero's forecast listens to. No motion at all for
// people who asked their OS for none.
export default class extends Controller {
  static targets = [
    "mixBtn",
    "goldBar", "goldPct", "stocksBar", "stocksPct", "cryptoBar", "cryptoPct"
  ]
  static values = {
    presets: Object, // RiskQuiz::PRESETS
    mix: { type: String, default: "balanced" },
    interval: { type: Number, default: 2800 }
  }

  connect() {
    this.apply()
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches
    if (!reduceMotion && this.mixes().length > 1) {
      this.timer = setInterval(() => this.advance(), this.intervalValue)
    }
  }

  disconnect() {
    this.stop()
  }

  selectMix(event) {
    this.stop()
    this.mixValue = event.params.mix
    this.apply()
  }

  advance() {
    const mixes = this.mixes()
    const next = (mixes.indexOf(this.mixValue) + 1) % mixes.length
    this.mixValue = mixes[next]
    this.apply()
  }

  stop() {
    clearInterval(this.timer)
    this.timer = null
  }

  mixes() {
    return Object.keys(this.presetsValue)
  }

  apply() {
    const split = this.presetsValue[this.mixValue]
    this.mixBtnTargets.forEach((chip) => {
      chip.setAttribute("aria-pressed", String(chip.dataset.mix === this.mixValue))
    })
    for (const bag of ["gold", "stocks", "crypto"]) {
      this[`${bag}BarTarget`].style.width = `${split[bag]}%`
      this[`${bag}PctTarget`].textContent = `${split[bag]}%`
    }
    this.dispatch("mix", { detail: { mix: this.mixValue } })
  }
}
